import Icon from '@ant-design/icons';
import { MouseEventHandler } from 'react';

interface IProps {
    className?: string;
    onClick?: MouseEventHandler<HTMLSpanElement>;
}

export const FullScreen = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.167 6.70835C13.5237 6.70835 13.8128 6.4192 13.8128 6.06251V2.83334C13.8128 2.66205 13.7448 2.49778 13.6237 2.37666C13.5026 2.25554 13.3383 2.1875 13.167 2.1875H9.93783C9.58114 2.1875 9.29199 2.47665 9.29199 2.83334C9.29199 3.19002 9.58114 3.47917 9.93783 3.47917H12.5212V6.06251C12.5212 6.4192 12.8103 6.70835 13.167 6.70835Z"
                    fill="#1B1B48"
                />
                <path
                    d="M8.64759 6.75593C8.89977 7.00811 9.30863 7.00812 9.56082 6.75595L12.9467 3.37029C13.199 3.11803 13.199 2.70903 12.9468 2.45677C12.6945 2.2045 12.2855 2.20451 12.0332 2.45678L8.64757 5.84271C8.3954 6.09489 8.39541 6.50376 8.64759 6.75593ZM2.64584 8.88267C2.28915 8.88267 2 9.17182 2 9.52851V12.7577C2 12.929 2.06804 13.0932 2.18916 13.2144C2.31028 13.3355 2.47455 13.4035 2.64584 13.4035H5.87501C6.2317 13.4035 6.52085 13.1144 6.52085 12.7577C6.52085 12.401 6.2317 12.1119 5.87501 12.1119H3.29167V9.52851C3.29167 9.17182 3.00252 8.88267 2.64584 8.88267Z"
                    fill="#1B1B48"
                />
                <path
                    d="M7.16463 8.8349C6.91245 8.58272 6.50359 8.58271 6.2514 8.83488L2.86548 12.2206C2.6132 12.4728 2.6132 12.8818 2.86546 13.1341C3.11772 13.3863 3.52672 13.3863 3.77898 13.1341L7.16464 9.74813C7.41681 9.49594 7.4168 9.08708 7.16463 8.8349Z"
                    fill="#1B1B48"
                />
            </svg>
        )}
    />
);

export const ExitFullScreen = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.05078 12.9465C7.41897 12.9465 7.71745 12.648 7.71745 12.2798V8.94645C7.71745 8.76964 7.64721 8.60007 7.52219 8.47505C7.39716 8.35002 7.22759 8.27979 7.05078 8.27979H3.71745C3.34926 8.27979 3.05078 8.57826 3.05078 8.94645C3.05078 9.31464 3.34926 9.61312 3.71745 9.61312H6.38412V12.2798C6.38412 12.648 6.68259 12.9465 7.05078 12.9465Z"
                    fill="#1B1B48"
                />
                <path
                    d="M9.8623 2.1097C9.49411 2.1097 9.19564 2.40818 9.19564 2.77637V6.1097C9.19564 6.28651 9.26588 6.45608 9.3909 6.58111C9.51592 6.70613 9.68549 6.77637 9.8623 6.77637H13.1956C13.5638 6.77637 13.8623 6.47789 13.8623 6.1097C13.8623 5.74151 13.5638 5.44303 13.1956 5.44303H10.529V2.77637C10.529 2.40818 10.2305 2.1097 9.8623 2.1097Z"
                    fill="#1B1B48"
                />
                <path
                    d="M6.99722 9.02797C6.73691 8.76766 6.31486 8.76765 6.05454 9.02796L2.55941 12.5228C2.299 12.7832 2.29899 13.2054 2.55939 13.4658C2.81979 13.7262 3.24198 13.7262 3.50237 13.4658L6.99724 9.97066C7.25754 9.71033 7.25754 9.28829 6.99722 9.02797Z"
                    fill="#1B1B48"
                />
                <path
                    d="M9.66684 6.30503C9.92715 6.56535 10.3492 6.56535 10.6095 6.30505L14.1047 2.81018C14.3651 2.54979 14.3651 2.1276 14.1047 1.8672C13.8443 1.6068 13.4221 1.60681 13.1617 1.86722L9.66682 5.36235C9.40652 5.62267 9.40653 6.04472 9.66684 6.30503Z"
                    fill="#1B1B48"
                />
            </svg>
        )}
    />
);

export const NewCreateQuestionSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2.715 10C2.715 5.97661 5.97661 2.715 10 2.715C14.0234 2.715 17.285 5.97661 17.285 10C17.285 14.0234 14.0234 17.285 10 17.285H4.66667C3.58879 17.285 2.715 16.4112 2.715 15.3333V10Z"
                    stroke="#1B1B48"
                    strokeWidth="1.43"
                />
                <rect x="5.5" y="9.57129" width="8.57143" height="1.42857" rx="0.714286" fill="#1B1B48" />
                <rect
                    x="9.07129"
                    y="14.5713"
                    width="8.57143"
                    height="1.42857"
                    rx="0.714286"
                    transform="rotate(-90 9.07129 14.5713)"
                    fill="#1B1B48"
                />
            </svg>
        )}
    />
);
